import { Alert, Typography } from '@mui/material';
import React from 'react';
import { describeOldServicePeriod, OLD_SERVICE_PERIOD_MONTHS } from './oldServicePeriod';

/**
 * The warning before allocating or approving a bill whose service period is long past (LB-6030), naming each period
 * and how long ago it ended. `periods` are `{ startDateOnly, endDateOnly, label }`, the label naming the table.
 * `unchecked` names tables whose period could not be read, so it is said rather than taken to be recent.
 */
export function OldServicePeriodWarning(_ref) {
  let _ref$periods = _ref.periods,
    periods = _ref$periods === void 0 ? [] : _ref$periods,
    sx = _ref.sx,
    _ref$unchecked = _ref.unchecked,
    unchecked = _ref$unchecked === void 0 ? [] : _ref$unchecked;
  if (!periods.length && !unchecked.length) return null;
  return /*#__PURE__*/React.createElement(Alert, {
    icon: false,
    severity: "warning",
    sx: sx
  }, periods.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, periods.length === 1 ? 'You’re billing for a service period' : 'You’re billing for service periods', " that ended more than ", OLD_SERVICE_PERIOD_MONTHS, " months ago. Are you sure?"), periods.map((period, index) => /*#__PURE__*/React.createElement(Typography, {
    key: "".concat(period.label || '', ":").concat(period.endDateOnly, ":").concat(index),
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, period.label ? "".concat(period.label, ": ") : '', describeOldServicePeriod(period))))) : null, unchecked.length ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, unchecked.length === 1 ? "The saved service period of ".concat(unchecked[0], " has not loaded yet, so it can\u2019t be checked. Make sure it did not end more than ").concat(OLD_SERVICE_PERIOD_MONTHS, " months ago.") : "The saved service periods of ".concat(unchecked.join(', '), " have not loaded yet, so they can\u2019t be checked. Make sure none ended more than ").concat(OLD_SERVICE_PERIOD_MONTHS, " months ago.")) : null);
}